import { Link } from 'react-router-dom';

import { useLocale } from 'context/locale-context';

const DashboardButtonFiles = () => {
  const { getLocaleOption } = useLocale();

  return (
    <Link
      to='/my-diagnostic-findings'
      className='p-button p-component text-center text-2xl home-dashboard-button'
    >
      {getLocaleOption('viewClinicDocuments')}
    </Link>
  );
};

export default DashboardButtonFiles;
